import React, { useState } from 'react';
import { api, resolveImg } from '../../api';
import ImageUploader from './ImageUploader';
import { Plus, Trash2, Save, X, Pencil } from 'lucide-react';

const empty = { img: '', nameFr: '', nameEn: '', material: 'Swarovski', priceFrom: '', order: 0 };

const StrassAdmin = ({ content, refresh }) => {
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const startNew = () => { setForm({ ...empty, order: (content.strass?.length || 0) }); setEditing('new'); };
  const startEdit = (s) => { setForm({
    img: s.img || '',
    nameFr: s.nameFr || '',
    nameEn: s.nameEn || '',
    material: s.material || 'Swarovski',
    priceFrom: s.priceFrom || '',
    order: s.order || 0,
  }); setEditing(s.id); };
  const cancel = () => { setEditing(null); setForm(empty); };

  const save = async () => {
    if (!form.img) { alert('Veuillez téléverser une photo'); return; }
    if (editing === 'new') {
      await api.post('/admin/strass', form);
    } else {
      await api.put(`/admin/strass/${editing}`, form);
    }
    await refresh();
    cancel();
  };

  const del = async (id) => {
    if (!window.confirm('Supprimer ce strass ?')) return;
    await api.delete(`/admin/strass/${id}`);
    await refresh();
  };

  const items = content.strass || [];

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="h-display text-[32px]">Strass dentaire</h2>
          <p className="text-[13px] text-[#8A8275] mt-1">Gérez vos modèles de strass dentaire. {items.length} pièces.</p>
        </div>
        <button onClick={startNew} className="btn-primary"><Plus size={14} /> Ajouter</button>
      </div>

      {editing && (
        <div className="bg-[#FAF8F4] border border-[#957340] p-6 mb-8">
          <div className="flex items-center justify-between mb-5">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#957340]">
              {editing === 'new' ? 'Nouveau strass' : 'Modifier'}
            </div>
            <button onClick={cancel}><X size={16} /></button>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            <div className="md:col-span-2">
              <ImageUploader value={form.img} onChange={(v) => setForm({ ...form, img: v })} label="Photo du strass" />
            </div>
            <Inp label="Nom (FR)" value={form.nameFr} onChange={(v) => setForm({ ...form, nameFr: v })} />
            <Inp label="Nom (EN)" value={form.nameEn} onChange={(v) => setForm({ ...form, nameEn: v })} />
            <Inp label="Matière (ex: Swarovski)" value={form.material} onChange={(v) => setForm({ ...form, material: v })} />
            <Inp label="Prix (ex: 30€) — laisser vide si non défini" value={form.priceFrom} onChange={(v) => setForm({ ...form, priceFrom: v })} />
            <Inp label="Ordre d'affichage" type="number" value={form.order} onChange={(v) => setForm({ ...form, order: parseInt(v) || 0 })} />
          </div>
          <div className="mt-6 flex gap-3">
            <button onClick={save} className="btn-primary"><Save size={14} /> Enregistrer</button>
            <button onClick={cancel} className="btn-ghost">Annuler</button>
          </div>
        </div>
      )}

      {items.length === 0 ? (
        <div className="text-center py-16 border border-dashed border-[#E8E2D5] bg-[#FAF8F4]">
          <p className="text-[14px] text-[#8A8275]">Aucun strass pour l'instant. Cliquez sur «Ajouter» pour téléverser vos premières photos.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5">
          {items.map((s) => (
            <div key={s.id} className="bg-white border border-[#E8E2D5] overflow-hidden">
              <div className="aspect-square bg-[#FAF8F4]">
                {s.img && <img src={resolveImg(s.img)} alt={s.nameFr} className="w-full h-full object-cover" />}
              </div>
              <div className="p-4">
                <div className="flex items-baseline justify-between">
                  <div className="serif text-[16px] text-[#1A1A1A]">{s.nameFr || '—'}</div>
                  {s.priceFrom && <div className="display text-[16px] text-[#957340]">{s.priceFrom}</div>}
                </div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-[#957340] mt-1">{s.material || ''}</div>
                <div className="flex gap-2 mt-4">
                  <button onClick={() => startEdit(s)} className="flex-1 border border-[#1A1A1A] py-2 text-[10px] tracking-[0.28em] uppercase hover:bg-[#1A1A1A] hover:text-white transition-colors flex items-center justify-center gap-2">
                    <Pencil size={12} /> Modifier
                  </button>
                  <button onClick={() => del(s.id)} className="px-3 py-2 border border-[#E8E2D5] text-[#8A8275] hover:text-red-600 hover:border-red-600 transition-colors">
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Inp = ({ label, value, onChange, type = 'text' }) => (
  <label className="block">
    <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">{label}</span>
    <input type={type} value={value ?? ''} onChange={(e) => onChange(e.target.value)}
      className="mt-2 w-full bg-white border border-[#E8E2D5] focus:border-[#957340] outline-none p-3 text-[14px] transition-colors" />
  </label>
);

export default StrassAdmin;
